import React from "react";
import Filters from "./Filters";
import CardsList from "./CardsList";
import { AppProvider } from "./Context";
import Pagination from "../Pagination/Pagination";
import PropTypes from "prop-types";

// all the logic of the app is handled in the app context file

const App = ({indexPage, lang}) => {
	return (
		<AppProvider indexPage={indexPage} language={lang}>
			<Filters />
			<CardsList />
			<Pagination />
		</AppProvider>
	);
};

App.propTypes = {
	indexPage: PropTypes.string,
	lang: PropTypes.string,
};

export default App;
